import { useTranslation } from 'react-i18next';
import { passwordScoreLabelKey } from '@/lib/passwordScore';
import { cn } from '@/lib/utils';

interface PwStrengthProps {
  score: number;
  className?: string;
}

// 4-bar meter + label. Color shifts from danger → warn → success as the
// score climbs. Used under the password input on register / accept-invite.
export function PwStrength({ score, className }: PwStrengthProps) {
  const { t } = useTranslation();
  const tone =
    score < 2
      ? 'bg-destructive text-destructive'
      : score < 3
        ? 'bg-warn text-warn'
        : 'bg-success text-success';
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <div className="flex flex-1 gap-1">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className={cn(
              'h-[3px] flex-1 rounded-full',
              i < score ? tone : 'bg-line',
            )}
          />
        ))}
      </div>
      <span className="min-w-[38px] text-right text-[11px] text-muted">
        {t(passwordScoreLabelKey(score))}
      </span>
    </div>
  );
}
